import React, { Component } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { banks } from '../../helpers/data';
import { allValid, validateName } from '../../helpers/validation';

class PaymentDetails extends Component {
  constructor (props) {
    super(props);
    this.state = {
      valid: {}
    };
  }

  updateField (path, value) {
    const data = this.props.data;
    path.reduce((acc, curr, i) => {
      if (i === path.length - 1) {
        acc[curr] = value;
        return true;
      } else {
        return acc[curr];
      }
    }, data);
    this.props.setData(data);
  }

  validate () {
    const paymentMethod = this.props.data.paymentMethod;
    const bankDetails = paymentMethod.bankDetails;
    const valid = {};

    valid.paymentMethod = {
      bankDetails: paymentMethod.type !== 'debit_order' ? true : {
        bankName: !!bankDetails.bankName && bankDetails.bankName !== 'select', // assume only valid options
        accountHolder: validateName(bankDetails.accountHolder),
        branchCode: bankDetails.branchCode && bankDetails.branchCode.length > 0,
        accountNumber: bankDetails.accountNumber && bankDetails.accountNumber.length > 0
      }
    };

    this.setState({ valid });

    return allValid(valid);
  }

  isValid (path) {
    const valid = this.state.valid;
    return !this.state.clicked || !!path.reduce((acc, curr) => acc && acc[curr], valid);
  }

  getValue (path) {
    const data = this.props.data;
    return path.reduce((acc, curr) => acc && acc[curr], data);
  }

  componentWillReceiveProps (props) {
    this.validate();
  }

  continue () {
    this.setState({ clicked: true });
    const isValid = this.validate();

    if (isValid) {
      this.props.nextStep();
    }
  }

  render () {
    return <div>
      <h1>Payment details</h1>
      <br />
      <h5>Please enter details for your monthly debit order</h5>
      <br />

      <Row>
        <Col>
          <p>
            <b>Bank details</b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='bankName'>Bank name</Label>
            <Input
              type='select'
              name='select'
              id='bankName'
              invalid={!this.isValid(['paymentMethod', 'bankDetails', 'bankName'])}
              value={this.getValue(['paymentMethod', 'bankDetails', 'bankName']) || 'select'}
              onChange={e => this.updateField(['paymentMethod', 'bankDetails', 'bankName'], e.target.value)}
            >
              <option value='select' disabled>Select bank</option>
              { banks.map(b => <option
                key={b.key}
                value={b.key}>
                {b.val}
              </option>)
              }
            </Input>
            <FormFeedback>A valid bank name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='branchCode'>Branch code</Label>
            <Input
              name='branchCode'
              id='branchCode'
              placeholder='Enter branch code'
              invalid={!this.isValid(['paymentMethod', 'bankDetails', 'branchCode'])}
              value={this.getValue(['paymentMethod', 'bankDetails', 'branchCode'])}
              onChange={e => this.updateField(['paymentMethod', 'bankDetails', 'branchCode'], e.target.value)}
            />
            <FormFeedback>A valid branch code is required</FormFeedback>
            {/* TODO: only ask for bank? */}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='accountHolder'>Account holder</Label>
            <Input
              name='accountHolder'
              id='accountHolder'
              placeholder='Enter account holder name'
              invalid={!this.isValid(['paymentMethod', 'bankDetails', 'accountHolder'])}
              value={this.getValue(['paymentMethod', 'bankDetails', 'accountHolder'])}
              onChange={e => this.updateField(['paymentMethod', 'bankDetails', 'accountHolder'], e.target.value)}
            />
            <FormFeedback>A valid name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='accountNumber'>Account number</Label>
            <Input
              name='accountNumber'
              id='accountNumber'
              placeholder='Enter account number'
              invalid={!this.isValid(['paymentMethod', 'bankDetails', 'accountNumber'])}
              value={this.getValue(['paymentMethod', 'bankDetails', 'accountNumber'])}
              onChange={e => this.updateField(['paymentMethod', 'bankDetails', 'accountNumber'], e.target.value)}
            />
            <FormFeedback>A valid account number is required</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='billingDay'>Billing day</Label>
            <Input
              type='select'
              name='billingDay'
              id='billingDay'
              value={this.getValue(['paymentMethod', 'billingDay']) || 1}
              onChange={e => this.updateField(['paymentMethod', 'billingDay'], e.target.value)}
            >
              <option key='1' value='1' selected='selected'>1st</option>
              <option key='7' value='7'>7th</option>
              <option key='15' value='15'>15th</option>
              <option key='27' value='27'>27th</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <br />
      <br />
      <Button color='primary' className='px-5' onClick={this.continue.bind(this)}>Continue</Button>
      <Button color='link' onClick={this.props.previousStep}>Back</Button>
    </div>;
  }
}

export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/components/application/payment-details.js